import { JSX } from "react";

export const NewButton = (props: {
    children: JSX.Element | string;
    onClick: () => void;
    primary?: boolean;
}) => {
    return (
        <div
            className={props.primary ? "new-button-primary" : "new-button"}
            onClick={props.onClick}
        >
            {props.children}
        </div>
    );
};
